export default {
    themes: {
        delete: "Themes successfully deleted",
        update: "Themes successfully updated",
        create: "Theme successfully created"
    },
    groups: {
        delete: "Groups successfully deleted",
        update: "Groups successfully updated",
        create: "Group successfully created"
    },
    users: {
        delete: "Users successfully deleted",
        update: "Users successfully updated",
        create: "User successfully created"
    },
    invites: {
        delete: "Invites successfully deleted",
        update: "Invites successfully updated",
        create: "Invite successfully created",
        resend: "Invites have been send"
    }
}
